import { RouteLocationRaw } from "vue-router"

import { Getters, store } from "@/store"

export default async (
  to,
  from,
  next: (arg?: RouteLocationRaw) => void
): Promise<void | boolean> => {
  const profile = store.getters[Getters.GET_USER_CURRENT_PROFILE]
  const accountByProfile = profile.accounts.find(a => a.urlName === to.params.accountId)
  if (accountByProfile && accountByProfile.enabled) {
    return next({ path: "/" })
  }
  next()
}
